<div class="square-lotto absolute left-0 flex row wrap y-items-center x-content-center full-width">
  <h3 class="lotto-box relative txt-left full-height light-2 uppercase flat-{{ 'logoFlat' | translate }}">
    <figure class="relative-left margin-right-10 top--25p">
      <app-logo-lotto></app-logo-lotto>
    </figure>
    <span class="lotto-name relative-left">
      {{lottoName}}
      <ng-container *ngIf="lottoId && lottoId!==2 && lottoId!==3; else MegaPower">
        <small class="block">{{country}}</small>
      </ng-container>
      <ng-template #MegaPower>
        <small class="block">{{'WORDS.team' | translate}}</small>
      </ng-template>
    </span>
  </h3>
</div>
<div class="square-jackpot relative-left flex row wrap y-items-center x-content-center full-width full-height">
  <h4 class="light-2 uppercase letter-spacing--05">
    <app-jackpot></app-jackpot>
  </h4>
</div>
<div class="square-date absolute bottom-0 left-0 full-width">
  <app-countdown></app-countdown>
</div>
<div class="more_chances" *ngIf="lottoId && lottoId==2 || lottoId==3">
  <p>{{'stickyText.' + lottoId + '.title' | translate}}</p>
</div>
